
import Sample from "../components/Render.jsx"
import { Navbar } from '../components/Navbar.tsx';
import { ThemeToggle } from "../components/ThemeToggle.tsx";
import React, { useEffect, useState, useRef, CSSProperties } from "react";
import { useNavigate, useParams } from "react-router";
import axios from "axios";
import FileSaver from "file-saver";
//import '../assets/tmp.css';
import useWindowDimensions from "../components/windowDimensions.jsx";
import { compile } from "path-to-regexp";
import SortableTree from 'react-sortable-tree';
import FileExplorerTheme from '@nosferatu500/theme-file-explorer';
import FolderTree, { testData } from 'react-folder-tree';
import 'react-folder-tree/dist/style.css';
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { FiCoffee } from "react-icons/fi";
import { SlControlStart } from "react-icons/sl";
import { FaDownload, FaRegSave } from "react-icons/fa";
import { FaRegFilePdf, FaUpload } from "react-icons/fa6";
import { FaRegSquarePlus } from "react-icons/fa6";
import { FiFileText } from "react-icons/fi";
import { RiDeleteBinLine } from "react-icons/ri";
import { BounceLoader } from "react-spinners";
import Switch from 'react-js-switch';
import CodeMirror, { Compartment } from '@uiw/react-codemirror';
import { latex } from 'codemirror-lang-latex';
import { solarizedLight, solarizedDark } from '@uiw/codemirror-theme-solarized';
import { EditorView } from "@codemirror/view"
import { history, historyKeymap } from '@codemirror/commands';
import { basicSetup } from "codemirror"
import { EditorState } from "@codemirror/state"
import { FaShareSquare } from "react-icons/fa";
import { Toaster, toast } from 'alert';
import { FaDoorOpen } from "react-icons/fa6";

let undoRedo = new Compartment;

const override: CSSProperties = {
    alignSelf: "center",
    padding: "2rem",
};
const Editor = () => {
    const editorRef = useRef(null);
    const [isUploading, setUploading] = useState(true);
    const [file, setFile] = useState([]);
    const [fileUrl, setFileUrl] = useState(null);
    const [checker, setChecker] = useState(false);
    const [seed, setSeed] = useState(1)
    const [files, setFiles] = useState([])
    const [currentFile, setCurrentFile] = useState(["main.tex", 0])
    const [logs, setLogs] = useState("");
    const [clicked, setClicked] = useState(false)
    const [fullList, setFullList] = useState([])
    const [listClicked, setListClicked] = useState(false)
    const [treeData, setTreeData] = useState({ assets: [{}] })
    const [entrypoint, setEntrypoint] = useState('main.tex')
    const [deleteMode, setDeleteMode] = useState(false)
    const [pdflatex, setPdflatex] = useState(true);
    const navigate = useNavigate()
    const [tmpimage, setTmpimage] = useState([])
    const [imagemode, setImagemode] = useState(false)
    const [changed, setChanged] = useState(0)
    const [current, setCurrent] = useState('')
    const api = "https://backend.coffeelatek.com";
    let { id } = useParams();

    const [path, setPath] = useState('')

    const onTreeStateChange = (state, event) => {
        if (deleteMode == null) {
            setTreeData(state)
            setDeleteMode(false)
        }
    };
    const share = () => {
        const email = prompt("insert the email of the other user")
        axios.post(api + "/api/doc/share/file/" + id, { 'mail': email }, {
            headers: {
                "Authorization": `Bearer ${localStorage.getItem('token')}`
            }
        }).then(async res => {
            if (res.status == 200) {
                toast.success("file shared")
            } else {
                toast.error('wrong email')
            }
        })
    }

    useEffect(() => {
        if (localStorage.getItem("token") == undefined) {
            navigate("/login")
        } else {
            if (checker == false) {
                axios.get(api + '/api/doc/check/' + id, {
                    headers: {
                        "Authorization": `Bearer ${localStorage.getItem('token')}`
                    }
                }).then(
                    res => {
                        if (res.status == 404) {

                            navigate("/search")
                        }
                    }
                ).catch(function () {

                    navigate("/search")
                })
                if (editorRef.current) {
                    editorRef.current.destroy()
                    editorRef.current = null
                }
                const ed = new EditorView({
                    state: EditorState.create({
                        options: {
                            mode: "text/x-stex",
                            lineWrapping: true,
                            smartIndent: true,
                            lineNumbers: true,
                            foldGutter: true,
                            autoCloseTags: true,
                            matchBrackets: true,
                            autoCloseBrackets: true,
                            autoRefresh: true,
                            lineBreak: true
                        },
                        extensions: [
                            latex(),
                            solarizedLight, EditorView.lineWrapping,
                            basicSetup,
                        ]
                    }),
                    parent: document.getElementById("ref")
                })
                editorRef.current = ed;

                axios.get(api + '/api/doc/assets/' + id, {
                    headers: {
                        "Authorization": `Bearer ${localStorage.getItem('token')}`
                    }
                }).then(
                    async res => {
                        if (res.status == 200) {
                            setTreeData(res.data)
                        }
                    }
                )
                axios.get(api + '/api/doc/entrypoint/get/' + id, {
                    headers: {
                        "Authorization": `Bearer ${localStorage.getItem('token')}`
                    }
                }).then(
                    async res => {
                        if (res.status == 200) {
                            setEntrypoint(res.data['entrypoint'])
                            setPath(res.data['entrypoint'])
                            axios.post(api + "/api/doc/get/file/" + id, { 'filename': res.data['entrypoint'] }, {

                                headers: {
                                    "Authorization": `Bearer ${localStorage.getItem("token")}`,

                                },
                            }).then(async res => {
                                setImagemode(false)

                                resetUndoRedo(res.data['data'])
                                //setEntrypoint(file_path)
                            })
                            setUploading(true)
                            // loadFiles();
                            axios.post(
                                api + "/api/doc/run/" + id,
                                {
                                    "entrypoint": res.data['entrypoint'],
                                    "pdflatex": pdflatex
                                }, {
                                headers: {
                                    "Authorization": `Bearer ${localStorage.getItem("token")}`
                                }
                            }
                            ).then(res => {
                                if (res.status == 200 || res.status == 201) {
                                    setLogs(res.data['output'])
                                    axios.get(api + "/api/doc/get/" + id, {
                                        responseType: "arraybuffer",
                                        headers: {
                                            "Authorization": `Bearer ${localStorage.getItem("token")}`,
                                            "Content-Type": "multipart/form-data",
                                        },
                                    }).then(res => {
                                        var file = new Blob([res.data], { type: 'application/pdf' })
                                        var fileUrl = URL.createObjectURL(file);
                                        setFileUrl(fileUrl)
                                        console.log(fileUrl)
                                        setSeed(Math.random())
                                        if (res.status == 200 || res.status == 201) {
                                            setUploading(false)
                                        } else {
                                            toast.error("internal server error");
                                        }
                                    }).catch(function () {
                                        //toast.error("check your latex code")
                                    })
                                } else { toast.error("LaTex code compiled but not saved") }
                            })
                        }
                    }
                )


                setChecker(true);
            }
        }

        const timer = setInterval(save, 30000);

        document.addEventListener('keydown', handleCtrl);
        return () => {
            clearInterval(timer);
            document.removeEventListener('keydown', handleCtrl);
        }


    })
    const download = () => {
        if (fileUrl != null) {
            window.open(fileUrl)
        }
    }

    const handleDelete = async (item) => {
        if (window.confirm(`Are you sure you want to delete "${item.split(' ').pop()}"?`)) {
            var ls = item.split(' ')
            var deleteName = ls[ls.length - 1]
            await axios.post(
                api + "/api/document/deletefile/" + id,
                {
                    "name": deleteName
                }).then(res => { if (res.status == 200 || res.status == 201) { toast.success(deleteName + " file deleted"); loadFiles() } else { toast.error("check the name of the file") } })
        }
    }

    const save = () => {
        if (path !== './') {
            try {
                if (editorRef.current) {
                    axios.post(api + '/api/doc/save/' + id, {
                        "filename": path,
                        'data': editorRef.current.state.doc.toString()
                    }, {
                        headers: {
                            "Authorization": `Bearer ${localStorage.getItem('token')}`
                        }
                    }).then(res => {
                        if (res.status == 200) {
                            console.log('file saved...')
                        }
                    })
                }
            } catch (e) {
                console.log('file error')
            }
        }


    }

    const handleCtrl = (e) => {
        if (e.key === 's' && e.ctrlKey) {
            e.preventDefault();
            console.log("pressed ctrl + s")
            save()
            Compile()
        }
    }
    const loadFiles = () => {
        axios.get(api + "/api/document/ls/" + id, {
            headers: {
                "Authorization": `Bearer ${localStorage.getItem('token')}`
            }
        }).then(async res => {
            if (res.status == 200 || res.status == 201) {
                const data = []
                const filenames = []
                for (var i in res.data["files"]) {
                    for (var item in res.data["files"][i]) {
                        var tmp = {}
                        console.log(item)
                        filenames.push(item)
                        tmp[item] = res.data["files"][i][item]
                        data.push(tmp)
                    }
                }
                setFiles(filenames)

                if (checker == false) {
                    setCurrentFile([filenames[0], 0])
                }
            }
        })
    }



    const createFile = async () => {
        let filename = prompt('add a file name:')
        if (path == '') {
            toast.error('You need to select a path before')
        } else {
            axios.post(
                api + '/api/doc/create/file/' + id, {
                'filename': filename,
                'path': path
            }
                ,
                {

                    headers: {
                        "Authorization": `Bearer ${localStorage.getItem('token')}`

                    }
                }
            ).then(res => {
                if (res.status == 200) {
                    axios.get(api + '/api/doc/assets/' + id, {
                        headers: {
                            "Authorization": `Bearer ${localStorage.getItem('token')}`
                        }
                    }).then(
                        async res => {
                            if (res.status == 200) {
                                setTreeData(res.data)


                            }
                        }
                    )
                }
            })
        }

    }

    const handleUpload = async (e) => {
        if (path == '') {
            toast.error('You need to select a path before')
        } else {


            const formData = new FormData();
            formData.append('file', e.target.files[0]);
            formData.append('path', path);
            if (file) {

                setUploading(true)
                axios
                    .post(
                        api + "/api/doc/upload/file/" + id,
                        formData,
                        {
                            withCredentials: false,
                            responseType: "arraybuffer",
                            headers: {
                                "Authorization": `Bearer ${localStorage.getItem('token')}`

                                , "Content-Type": "multipart/form-data",
                            },
                        }
                    )
                    .then((response) => {
                        if (response.status == 200 || response.status == 201) {
                            axios.get(api + '/api/doc/assets/' + id, {
                                headers: {
                                    "Authorization": `Bearer ${localStorage.getItem('token')}`
                                }
                            }).then(
                                async res => {
                                    if (res.status == 200) {
                                        setTreeData(res.data)

                                        toast.success("file uploaded")
                                    }
                                }
                            )

                        }

                    })
                    .catch(function () {
                        toast.error("check your file")
                    })
                setUploading(false)
                e.target.value=""
            }
        }
    }
    function resetUndoRedo(text) {
        if (editorRef.current) {
            editorRef.current.destroy()
            editorRef.current = null
        }

        const ed = new EditorView({
            state: EditorState.create({
                basicSetup,
                height: "500px",
                options: {
                    mode: "text/x-stex",
                    lineWrapping: true,
                    smartIndent: true,
                    lineNumbers: true,
                    foldGutter: true,
                    autoCloseTags: true,
                    matchBrackets: true,
                    autoCloseBrackets: true,
                    autoRefresh: true,
                    lineBreak: true,
                    autoRefresh: true
                },
                doc: text,
                extensions: [
                    latex(),
                    solarizedLight, EditorView.lineWrapping,
                    basicSetup,
                ]
            }),
            parent: document.getElementById("ref")
        })
        editorRef.current = ed;



    }
    const deleteFile = () => {
        const p = prompt('Is this the file/folder you want to delete', path);
        if (p == null) {
            console.log('canceled')
        } else {
            axios.post(api + '/api/doc/file/delete/' + id, { 'filename': p }, {
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem("token")}`,

                }
            }).then(res => {
                if (res.status == 200) {
                    axios.get(api + '/api/doc/assets/' + id, {
                        headers: {
                            "Authorization": `Bearer ${localStorage.getItem('token')}`
                        }
                    }).then(
                        async res => {
                            if (res.status == 200) {
                                setTreeData(res.data)
                                setPath("")
                                if (editorRef.current) {
                                    editorRef.current.destroy()
                                    editorRef.current = null
                                }
                                setDeleteMode(null)
                            }
                        }
                    )


                }
            })
        }

    }

    const getFilePath = (nodeData) => {
        const { path } = nodeData;
        if (path.length === 0) return './'
        if (path.length < 2) return treeData.children[path[0]].name
        return treeData.children[path[0]].name + '/' + treeData.children[path[0]].children[path[1]].name
    }

    const ActiveFileIcon = ({ className, onClick, nodeData }) => {
        const isActive = path !== '' && getFilePath(nodeData) === path;
        return (
            <FiFileText
                className={className}
                onClick={onClick}
                style={isActive ? { color: 'var(--primary-color)' } : undefined}
                title={isActive ? 'Currently open' : undefined}
            />
        )
    }

    const onNameClick = ({ defaultOnClick, nodeData }) => {
        defaultOnClick();
        setChanged(changed + 1)

        try {
            const {
                path, name
            } = nodeData;
            const file_path = getFilePath(nodeData);
            if (path.length < 2) {
                setPath(file_path)
            }


            if ((/\.(png|jpeg||jpg)$/i).test(name)) {

                axios.post(api + "/api/doc/download/file/" + id, { 'filename': file_path }, {
                    responseType: "arraybuffer",
                    headers: {

                        "Authorization": `Bearer ${localStorage.getItem("token")}`
                    }
                }).then(res => {
                    if (editorRef.current) {
                        editorRef.current.destroy()
                        editorRef.current = null
                    }

                    var file = new Blob([res.data])
                    var fileUrl = URL.createObjectURL(file);
                    setTmpimage(fileUrl)
                    setImagemode(true)
                    setPath(file_path)

                }).catch(function () {
                    //toast.error("Internal server error...")
                })

            } else if (!(/\.(pdf)$/i).test(name) && file_path !== './') {


                axios.post(api + "/api/doc/get/file/" + id, { 'filename': file_path }, {

                    headers: {
                        "Authorization": `Bearer ${localStorage.getItem("token")}`,

                    },
                }).then(async res => {
                    setImagemode(false)
 
                    resetUndoRedo(res.data['data'])
                    setPath(file_path)
                    //setEntrypoint(file_path)
                })
            }

        } catch (e) {
            console.log('an error occured')
        }

    };

    const setEntry = () => {

        if ((/\.(tex)$/i).test(path)) {
            axios.post(api + "/api/doc/entrypoint/" + id, { 'entrypoint': path }, {

                headers: {
                    "Authorization": `Bearer ${localStorage.getItem("token")}`,

                },
            }).then(async res => {
                setEntrypoint(path)
                //setEntrypoint(file_path)
            })
        }
    }
    const handleDownload = () => {

        axios.post(api + "/api/doc/download/file/" + id, { 'filename': path }, {
            responseType: "arraybuffer",
            headers: {

                "Authorization": `Bearer ${localStorage.getItem("token")}`
            }
        }).then(res => {
            var file = new Blob([res.data])
            var name = path.split('/')
            FileSaver.saveAs(file, name[name.length - 1])

        }).catch(function () {
            toast.error("Internal server error...")
        })
    }


    //Update current file then run the project uing that entrypoint
    const Compile = async () => {

        setUploading(true)
        // loadFiles();
        await axios.post(
            api + "/api/doc/run/" + id,
            {
                "entrypoint": entrypoint,
                "pdflatex": pdflatex
            }, {
            headers: {
                "Authorization": `Bearer ${localStorage.getItem("token")}`
            }
        }
        ).then(res => {
            if (res.status == 200 || res.status == 201) {
                setLogs(res.data['output'])
                axios.get(api + "/api/doc/get/" + id, {
                    responseType: "arraybuffer",
                    headers: {
                        "Authorization": `Bearer ${localStorage.getItem("token")}`,
                        "Content-Type": "multipart/form-data",
                    },
                }).then(res => {
                    var file = new Blob([res.data], { type: 'application/pdf' })
                    var fileUrl = URL.createObjectURL(file);
                    setFileUrl(fileUrl)
                    console.log(fileUrl)
                    setSeed(Math.random())
                    if (res.status == 200 || res.status == 201) {
                        setUploading(false)
                    } else {
                        toast.error("internal server error");
                    }
                }).catch(function () {
                    toast.error("check your latex code")
                })
            } else { toast.error("LaTex code compiled but not saved") }
        })
    }

    const handleCompiler = () => {
        setPdflatex(!pdflatex)
    }


    return (
        <div className="first-color" style={{ height: '100vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>

            <Toaster position='top-center' />
            <PanelGroup direction="horizontal">
                <Panel defaultSize={15} minSize={10} style={{ display: 'flex', flexDirection: 'column' }}>
                    <div>
                        <div className="box third-color" style={{ display: 'flex', alignItems: 'center', gap: '1rem', padding: '0.5rem' }}>
                            <strong className="logo" onClick={() => { navigate('/search') }} style={{ cursor: 'pointer', fontSize: '2.2rem', display: 'flex', alignItems: 'center', gap: '0.5rem', margin: 0, padding: '0.5rem 1rem', borderRadius: '0.4rem', border: 'none', backgroundColor: 'var(--text-color)', color: 'var(--background-color)' }}>
                                <FiCoffee /> CoffeeLaTek 
                            </strong>
                            <ThemeToggle />
                        </div>
                    </div>
                    <div style={{ padding: '0 1rem' }}>
                        <small className="break">Entrypoint: {entrypoint}</small>
                    </div>
                    <div className="box">
                        <div className="one">
                            <a className="button button-clear float-left" title='entrypoint' onClick={setEntry} ><FaDoorOpen /></a>
                        </div>
                        <div className="one">
                            <a className="button button-clear float-left" title='create file' onClick={createFile} ><FaRegSquarePlus /></a>
                        </div>
                        <div className="one">
                            <a className="button button-clear float-left" title='delete file' onClick={deleteFile} ><RiDeleteBinLine /></a>
                        </div>
                        <div className="one">
                            <a className="button button-clear float-left" title='download file' onClick={handleDownload} ><FaDownload /></a>
                        </div>
                        <div className="one">
                            <label htmlFor="files" className="button button-clear file-label float-left" title='upload file'><FaUpload /></label>
                            <input className="hide" id="files" type="file" onChange={handleUpload} />
                        </div>
                    </div>

                    <div className="scroll" style={{ flex: 1, overflowY: 'auto' }}>
                        <FolderTree
                            showCheckbox={false}
                            data={treeData}
                            onChange={onTreeStateChange}
                            onNameClick={onNameClick}
                            iconComponents={{ FileIcon: ActiveFileIcon }}
                            readOnly
                        />
                        <br /><br /><br /><br /><br />
                    </div>
                </Panel>

                <PanelResizeHandle />

                <Panel defaultSize={45} minSize={20} style={{ display: 'flex', flexDirection: 'column' }}>
                    <div className="box">
                        <div className="one">
                            <button title="Run project with current file as entrypoint" className="button button-clear float-left" onClick={() => { save(); Compile() }} ><SlControlStart /></button>
                            <button className="button  button-clear float-left" onClick={save} title="Save current file"><FaRegSave /></button>
                            <button className="button button-clear float-left" title="downlad pdf" onClick={download}  ><FaRegFilePdf /></button>
                            <button className="button button-clear float-left" title="share document" onClick={share} ><FaShareSquare /> </button>
                            <button className="button button-clear  float-left" title="Show logs" onClick={() => { setClicked(!clicked) }}><FiFileText /></button>
                        </div>
                        <div className="one">
                            <button className="button button-black float-right" title="share document" onClick={handleCompiler} >{pdflatex ? "pdfLaTeX" : "XeLateX"}</button>
                        </div>
                    </div>
                    <div style={{ padding: '0 1rem' }}>
                        <small className="break">Selected: {path == './' ? 'root >' : 'root > ' + path.replace('/', ' > ')}</small>
                    </div>
                    <div id="ref-container" style={{ flex: 1, overflow: 'hidden', position: 'relative' }}>
                        {imagemode == true ? (
                            <div className="cn" style={{ height: '100%' }}>
                                <center><img className="i im" src={tmpimage} style={{ maxHeight: '100%', maxWidth: '100%' }} /></center>
                            </div>
                        ) : (
                            <div id="ref" style={{ height: '100%' }}></div>
                        )}
                    </div>
                </Panel>

                <PanelResizeHandle />

                <Panel defaultSize={40} minSize={20} style={{ display: 'flex', flexDirection: 'column' }}>
                    {clicked == true && listClicked == false ? (
                        <div className="container sm" style={{ flex: 1, overflowY: 'auto', padding: '1rem' }}>
                            <br /><h4>Logs: </h4> <br />
                            <div className="first-color container lg log">
                                <p style={{ whiteSpace: 'pre-wrap' }}>{logs}</p>
                            </div>
                        </div>
                    ) : listClicked == true ? (
                        <div className="container sm" style={{ flex: 1, overflowY: 'auto', padding: '1rem' }}>
                            <div className="log">
                                <br /><h4>Files: (Click to delete) </h4> <br />
                                <div className="second-color"> <strong>Size(KB)  Date        Filename </strong></div> <br />
                                {fullList.map((item, idx) => (
                                    <div key={idx} className="second-color" onClick={() => { handleDelete(item) }} style={{ cursor: 'pointer' }}>
                                        <p>{item}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : (
                        <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                            {isUploading == true ? (
                                <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <BounceLoader
                                        color={localStorage.getItem('theme') === 'light' ? '#252525' : '#F5F5F5'}
                                        loading={true}
                                        cssOverride={override}
                                        size={150}
                                        aria-label="Loading Spinner"
                                        data-testid="loader"
                                    />
                                </div>
                            ) : (
                                <div className="container sm" style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                                    <Sample file={fileUrl} key={seed} />
                                </div>
                            )}
                        </div>
                    )}
                </Panel>
            </PanelGroup>
        </div>
    )
}
export default Editor;
